import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  SHOP_PRODUCT_LIST_BLOCK_DATA_SOURCE,
  ShopProductListBlockDataSource,
} from './shop-product-list-block-view-model';
import { ShopProductListBlockPreviewDataSource } from './shop-product-list-block-preview-data-source';
import { ShopProductListBlockStoreDataSource } from './shop-product-list-block-store-data-source';

export function provideShopProductListBlockDataSource(): Provider[] {
  return [
    ShopProductListBlockStoreDataSource,
    ShopProductListBlockPreviewDataSource,
    {
      provide: SHOP_PRODUCT_LIST_BLOCK_DATA_SOURCE,
      useFactory: (): ShopProductListBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(ShopProductListBlockPreviewDataSource)
          : inject(ShopProductListBlockStoreDataSource);
      },
    },
  ];
}
